import { styled, Typography } from "@mui/material";

export const AcxGradientTypography = styled(Typography)(() => ({
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    color: "transparent",
    background:
        "linear-gradient(131deg, #32D1B7 3.43%, #349AC7 70.89%, #3664D6 100.5%)",
    backgroundClip: "text",
}));
